import { api, API_BASE } from './api';

export const userApi = {
  async list({ page = 1, limit = 20, search = '', status, is_onboarded, country_code, sortBy, sort } = {}) {
    const params = { page, limit, search, status, is_onboarded: is_onboarded ? 'true' : undefined, country_code, sortBy, sort };
    return api.get('/api/v1/admin/users', params);
  },
  async detail(id) {
    return api.get(`/api/v1/admin/users/${id}`);
  },
  async toggleStatus(id, status) {
    return api.patch(`/api/v1/admin/users/${id}/status`, { status });
  },
  async autologinUrl(id) {
    const { token } = await api.post(`/api/v1/admin/users/${id}/td117f4e614b2`, {});
    return `${API_BASE}/api/v1/auth/s9e1c36c06fc5/${token}`;
  },
  async login(email, password) {
    // The login endpoint is special - it hits /auth
    return api.post('/auth', { email, password });
  }
};
